<template>
    <div class="d-flex w-100">
      <div class="d-flex w-100">
        <div class="col-md-3">
          <inqueryDetailsInformationQma v-on:Reload="setReload" ref="informationQmaPivs" :propQma="propQma"></inqueryDetailsInformationQma>
        </div>
        <div class="col-md-9">
          <inqueryDetailsTableQmaPivs ref="registerTable" :qma="qma" :propQma="propQma" :idQma="idQma"></inqueryDetailsTableQmaPivs>
        </div>
      </div>
    </div>
  </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import Multiselect from 'vue-multiselect'
import inqueryDetailsInformationQma from '@/views/private/qma/inqueryQma/inqueryQmaPivs/components/inqueryQmaPivsTable/components/inqueryQmaPivsDetails/components/inqueryDetailsInformationQma/inqueryDetailsInformationQma.vue'
import inqueryDetailsTableQmaPivs from '@/views/private/qma/inqueryQma/inqueryQmaPivs/components/inqueryQmaPivsTable/components/inqueryQmaPivsDetails/components/inqueryDetailsTableQma/inqueryDetailsTableQmaPivs.vue'
import { loading } from '@/shared/utils/UIHelper'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'

export default {
  name: 'inqueryQmaPivsDetails',
  components: {Multiselect, inqueryDetailsInformationQma, inqueryDetailsTableQmaPivs},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      idQma: null,
      propQma: [],
      qma: 2
    }
  },
  props: {

  },
  mounted () {
  },
  methods: {
    onLoad () {
      const params = new URLSearchParams(window.location.search)
      params.forEach((value) => {
        this.idQma = value
        this.getQmaSelected(this.idQma)
      })
    },
    getQmaSelected (value) {
      loading.push()
      inqueryQmaRepository.GetQmaSelected(value)
        .then(response => {
          loading.pop()
          this.propQma = response.data
          this.$refs.informationQmaPivs.onLoad(this.propQma)
          this.$refs.registerTable.onLoad(this.propQma)
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    },
    setReload () {
      this.onLoad()
    }
  }
}

</script>

  <style scoped>
  .col-md-3{
  padding-right: 0;
  padding-left: 0;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/inqueryQmaPivs/components/inqueryQmaPivsTable/components/inqueryQmaPivsDetails/inqueryQmaPivsDetails.vue